<div class="item-content">
  <div class="help-first-line">
    <strong><%= I18n.header.title %></strong>
  </div>
  <div class="help-second-line">
    <%= I18n.header.need_help %> <a href="tel:<%- booking.validated_booking_number || booking.booking_number || I18n.help_phone_number %>"><%- booking.validated_booking_number || booking.booking_number || I18n.help_phone_number %></a>
  </div>
</div>
